import { css, useTheme } from '@emotion/react';

import { fontSizes, radii, spacing } from '@/theme/tokens';

export interface StatCardProps {
  label: string;
  value: string;
  color?: string;
}

export function StatCard({ label, value, color }: StatCardProps) {
  const theme = useTheme();

  return (
    <div
      css={css`
        background: ${theme.colors.surface};
        border: 1px solid ${theme.colors.border};
        border-radius: ${radii.lg};
        padding: ${spacing.md} ${spacing.lg};
        text-align: center;
        min-width: 120px;
      `}
    >
      <div
        css={css`
          font-size: ${fontSizes.xs};
          color: ${theme.colors.textSecondary};
          text-transform: uppercase;
          letter-spacing: 0.2px;
          margin-bottom: 6px;
        `}
      >
        {label}
      </div>
      <div
        css={css`
          font-size: 2rem;
          font-weight: 300;
          font-variant-numeric: tabular-nums;
          color: ${color ?? theme.colors.text};
          line-height: 1;
        `}
      >
        {value}
      </div>
    </div>
  );
}
